import React from 'react'
import withoutHydration from 'react-without-hydration'
import { withParsedContext } from '../../withJSSContext'

interface Props {
  parsedRouteFields: {
    'Shorthand Src': string
    'Shorthand Data Id'?: string
    'Shorthand Code'?: string
  }
}

const MagazinesShorthandModule: React.FC<Props> = React.memo(({ parsedRouteFields }) => {
  const shorthandProps = {
    src: parsedRouteFields?.['Shorthand Src'],
    ...(parsedRouteFields?.['Shorthand Data Id'] && { 'data-id': parsedRouteFields?.['Shorthand Data Id'] }),
    ...(parsedRouteFields?.['Shorthand Code'] && { 'data-shorthand': parsedRouteFields?.['Shorthand Code'] }),
  }

  return (
    <div>
      <div {...shorthandProps} />
      <script type="text/javascript" src={parsedRouteFields?.['Shorthand Src']} />
    </div>
  )
})

MagazinesShorthandModule.displayName = 'MagazinesShorthandModule'

export default withoutHydration()(withParsedContext(MagazinesShorthandModule as React.FC))
